import { apiInstance } from 'api/utils';

export default {
  getKiidDocument: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/kiid',
      data
    })
};
